import React from "react"
import PropTypes from "prop-types"
import { Button, Flex, Spin } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import { Text } from "ui/Typography"
import { useTranslation } from "react-i18next"
import EquipmentTable from "../EquipmentTable"
import styles from "./index.module.css"

const AssignedEquipmentSection = ({ equipment, onUnassign, onToggleAdd, canEdit, fetchLoading, unassignLoading }) => {
  const { t } = useTranslation()

  const handleUnassign = (item) => {
    onUnassign(item.equipmentId, item.assetId)
  }

  return (
    <div className={styles.section}>
      <div className="mb-xl">
        <Flex align="center" gap={8} className="mb-xs">
          <Text fw={600} size="xl">
            {t("booking.equipment.assigned_equipment")}
          </Text>
          <Text className={styles.countText}>({equipment.length})</Text>
        </Flex>
        <Text className={styles.descriptionText}>{t("booking.equipment.assigned_equipment_description")}</Text>
      </div>

      <Flex vertical gap={12}>
        {fetchLoading ? (
          <Spin spinning />
        ) : (
          <EquipmentTable
            equipment={equipment}
            onAction={handleUnassign}
            actionType="unassign"
            emptyMessage={t("booking.equipment.no_assigned_equipment")}
            canEdit={canEdit}
            loading={unassignLoading}
          />
        )}

        {canEdit && (
          <div className="px-xl">
            <Button type="link" icon={<PlusOutlined />} className={styles.addButton} onClick={onToggleAdd}>
              {t("booking.equipment.add_equipment_button")}
            </Button>
          </div>
        )}
      </Flex>
    </div>
  )
}

AssignedEquipmentSection.propTypes = {
  equipment: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      equipmentId: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      assetNumber: PropTypes.string.isRequired,
      assetId: PropTypes.number.isRequired,
      category: PropTypes.string.isRequired
    })
  ).isRequired,
  onUnassign: PropTypes.func.isRequired,
  onToggleAdd: PropTypes.func.isRequired,
  canEdit: PropTypes.bool,
  fetchLoading: PropTypes.bool,
  unassignLoading: PropTypes.bool
}

export default AssignedEquipmentSection
